class VtUgcSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track) return;

    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.onDesktopChange = () => this.syncArrows();

    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
    window.addEventListener('resize', this.onDesktopChange, { passive: true });
    this.desktopQuery.addEventListener('change', this.onDesktopChange);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.syncArrows());
      this.resizeObserver.observe(this.track);
    }

    this.syncArrows();
    requestAnimationFrame(() => this.syncArrows());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onDesktopChange);
    this.desktopQuery?.removeEventListener('change', this.onDesktopChange);
  }

  scrollByCard(direction) {
    const cards = [...this.track.querySelectorAll('.vt-ugc__card')];
    if (!cards.length) return;

    const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 16;
    const cardWidth = cards[0].getBoundingClientRect().width;
    const step = cardWidth + gap;
    const target = this.track.scrollLeft + step * direction;

    this.track.scrollTo({ left: target, behavior: 'smooth' });
  }

  syncArrows() {
    const cards = this.track.querySelectorAll('.vt-ugc__card');
    const isDesktop = this.desktopQuery?.matches ?? window.innerWidth >= 990;
    const cardCount = cards.length;
    const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);

    const hideOnDesktop = isDesktop && cardCount <= 4;
    const hasOverflow = !hideOnDesktop && isDesktop && max > 2;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= max;

    this.classList.toggle('is-static', hideOnDesktop || !hasOverflow);

    if (this.prev) {
      this.prev.disabled = !hasOverflow || atStart;
      this.prev.classList.toggle('is-hidden', hideOnDesktop || !hasOverflow);
    }
    if (this.next) {
      this.next.disabled = !hasOverflow || atEnd;
      this.next.classList.toggle('is-hidden', hideOnDesktop || !hasOverflow);
    }
  }
}

if (!customElements.get('vt-ugc-slider')) {
  customElements.define('vt-ugc-slider', VtUgcSlider);
}
